import React  from 'react';
import styles from 'components/LoaderDots/LoaderDots.scss';

const LoaderDots = (props) => {
  return (
    <div className={[
      styles.loaderDots,
      props.theme ? styles[props.theme] : null,
    ].join(' ')}></div>
  );
}

export default LoaderDots;
